export const LOGIN_USER = {
  email: "",
  password: "",
};

export const FORGOT_PASSWORD = {
  email: "",
};

export const RECOVERY_PASSWORD = {
  password: "",
  confirm_password: "",
};

export const DEFAULT_USER = {
  name: "",
  last_name: "",
  password: "",
  email: "",
  role: "",
};

export const DEFAULT_CAR = {
  license: "",
  customer_name: "",
  customer_id: "",
  phone: "",
  brand: "",
  model: "",
  kms: "",
  date: new Date().toLocaleDateString("es-CL"),
  motor_type: "",
  year: "",
  customerId: "",
  /*   worker: "", */
};

export const DEFAULT_CUSTOMER = {
  name: "",
  customer_id: "",
  phone: "",
  email: "",
  address: "",
};

export const DEFAULT_VEHICLE_TYPE = {
  name: "",
  description: "",
};

export const SERVICES_COLUMNS = [
  { title: "Nombre", field: "title", inputType: "text", cellStyle: { color: "#fff" } },
  { title: "Intervalo", field: "interval", inputType: "number", cellStyle: { color: "#fff" } },
  { title: "Descripción", field: "description", inputType: "text", cellStyle: { color: "#fff" } },
  {
    title: "Fecha",
    field: "date",
    inputType: "date",
    cellStyle: { color: "#fff" },
  },
  {
    title: "Mecánico",
    field: "worker",
    inputType: "readonly",
    cellStyle: { color: "#fff" },
  },
  {
    title: "Próxima mantención",
    field: "nextService",
    inputType: "number",
    cellStyle: { color: "#fff" },
  },
];
export const REGISTER_COLUMNS = [
  {
    title: "Patente",
    field: "license",
    cellStyle: { color: "#fff" },
  },
  {
    title: "Nombre cliente",
    field: "customer_name",
    cellStyle: { color: "#fff" },
  },
  { title: "Rut cliente", field: "customer_id", cellStyle: { color: "#fff" } },
  {
    title: "telefono",
    field: "phone",
    cellStyle: { color: "#fff" },
  },
  {
    title: "Marca",
    field: "brand",
    cellStyle: { color: "#fff" },
  },
  {
    title: "Modelo",
    field: "model",
    cellStyle: { color: "#fff" },
  },
  {
    title: "kms",
    field: "kms",
    cellStyle: { color: "#fff" },
  },
  {
    title: "Fecha",
    field: "date",
    cellStyle: { color: "#fff" },
  },
];

export const USERS_COLUMNS = [
  {
    title: "Nombre",
    field: "name",
    cellStyle: { color: "#fff" },
  },
  { title: "Apellido", field: "last_name", cellStyle: { color: "#fff" } },
  {
    title: "Email",
    field: "email",
    cellStyle: { color: "#fff" },
  },
  {
    title: "Rol",
    field: "role",
    cellStyle: { color: "#fff" },
  },
];

export const RECORD_HEADERS = [
  "Patente",
  "Nombre cliente",
  "Rut cliente",
  "telefono",
  "Marca",
  "Modelo",
  "kms",
  "Fecha",
  "Acciones",
];

export const VEHICLE_TYPES_COLUMNS = [
  { title: "Nombre", field: "name", cellStyle: { color: "#fff" } },
  { title: "Descripción", field: "description", cellStyle: { color: "#fff" } },
];

export const CUSTOMERS_COLUMNS = [
  { title: "Nombre", field: "name", cellStyle: { color: "#fff" } },
  { title: "RUT", field: "rut", cellStyle: { color: "#fff" } },
  { title: "Teléfono", field: "phone", cellStyle: { color: "#fff" } },
  { title: "Email", field: "email", cellStyle: { color: "#fff" } },
];
